module.exports = __webpack_public_path__ + "static/sponsorship_img1M@2x-0f4d01bfe971a0b5cf499add462a83f8.jpg";